import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1180px]" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-3" }
const _hoisted_3 = {
  "data-test": "day-card",
  class: "rounded-lg bg-white px-4 py-5 shadow sm:p-6"
}
const _hoisted_4 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_5 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_8 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = {
  "data-test": "day-card",
  class: "rounded-lg bg-white px-4 py-5 shadow sm:p-6"
}
const _hoisted_13 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_14 = { class: "mt-8" }
const _hoisted_15 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_16 = {
  "data-test": "location-cell",
  class: "min-w-0"
}
const _hoisted_17 = { class: "truncate font-medium text-gray-900" }
const _hoisted_18 = {
  key: 0,
  class: "truncate text-xs text-gray-500"
}
const _hoisted_19 = { "data-test": "location-cell" }
const _hoisted_20 = { "data-test": "location-cell" }
const _hoisted_21 = { "data-test": "location-cell" }
const _hoisted_22 = { "data-test": "location-cell" }
const _hoisted_23 = {
  key: 2,
  "data-test": "quiet-locations",
  class: "mt-3 text-sm text-gray-500"
}

import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import EmptyState from '@/components/neue/EmptyState.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import { formatDollars } from '@/helpers/money'


export default {
  __name: 'FranchiseDayOverview',
  props: { day: { type: Object, required: true } },
  setup(__props) {

const props = __props

const COLUMNS = ['2fr', '1fr', '1fr', '1fr', '1fr', '1fr']

const store = useStore()
const router = useRouter()

const hideNumbers = computed(() => !!store.state.hideNumbers)
const totals = computed(() => props.day.summary.value?.totals ?? {})
const ACTIVITY = ['orders', 'unpacked', 'unpaid_carts', 'drops']
const hadActivity = location => ACTIVITY.some(key => (location[key] ?? 0) > 0)

const allLocations = computed(() => props.day.summary.value?.locations ?? [])
// Only the locations with something on the day, busiest first; the rest are counted under the table.
const locations = computed(() =>
  allLocations.value.filter(hadActivity).sort((a, b) => (b.orders ?? 0) - (a.orders ?? 0))
)
const quietCount = computed(() => allLocations.value.length - locations.value.length)

const dollars = cents => formatDollars((cents ?? 0) / 100)

// drop_open is null when the location has no drop on the day.
const dropsLabel = location => {
  if (location.drop_open === null || !location.drops) return 'none'
  return `${location.drops} ${location.drop_open ? 'open' : 'closed'}`
}

// Switches to the location first, as the switcher does, so both ways in agree.
const openLocation = async location => {
  const date = props.day.date.value
  await store.dispatch('setActiveFranchiseMerchant', String(location.merchant_id))
  router.push(`/dashboard/days/${date}/locations/${location.merchant_id}/overview`)
}

onMounted(() => props.day.loadSummary())

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NeueLoading, {
      loading: __props.day.loading.summary
    }, {
      default: _withCtx(() => [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Orders", -1)),
            _createElementVNode("dd", _hoisted_4, _toDisplayString(totals.value.orders ?? 0), 1),
            _createElementVNode("dd", _hoisted_5, [
              _cache[0] || (_cache[0] = _createTextVNode(" Cancelled: ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(totals.value.cancelled ?? 0), 1)
            ])
          ]),
          _createElementVNode("div", {
            "data-test": "day-card",
            class: _normalizeClass(["rounded-lg bg-white px-4 py-5 shadow sm:p-6", hideNumbers.value && 'blur-lg'])
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Total amount", -1)),
            _createElementVNode("dd", _hoisted_7, _toDisplayString(dollars(totals.value.total_cents)), 1),
            _createElementVNode("dd", _hoisted_8, [
              _cache[2] || (_cache[2] = _createTextVNode(" Average order: ", -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(dollars(totals.value.average_order_cents)), 1)
            ]),
            _createElementVNode("dd", _hoisted_10, [
              _cache[3] || (_cache[3] = _createTextVNode(" Unpacked: ", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(totals.value.unpacked ?? 0), 1)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Unpaid carts", -1)),
            _createElementVNode("dd", _hoisted_13, _toDisplayString(totals.value.unpaid_carts ?? 0), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "mb-4 text-lg font-semibold text-gray-900" }, "Locations", -1)),
          (locations.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(NeueTablist, null, {
                  head: _withCtx(() => [
                    _createVNode(TablistHeader, null, {
                      default: _withCtx(() => [
                        _createVNode(TablistGrid, {
                          columns: COLUMNS,
                          header: ""
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("div", null, "Location", -1),
                            _createElementVNode("div", null, "Orders", -1),
                            _createElementVNode("div", null, "Total", -1),
                            _createElementVNode("div", null, "Unpacked", -1),
                            _createElementVNode("div", null, "Unpaid carts", -1),
                            _createElementVNode("div", null, "Drops", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location) => {
                      return (_openBlock(), _createBlock(TablistRow, {
                        key: location.merchant_id,
                        "data-test": "location-row",
                        class: "cursor-pointer",
                        role: "button",
                        tabindex: "0",
                        onKeydown: [
                          _withKeys(_withModifiers($event => (openLocation(location)), ["prevent"]), ["enter"]),
                          _withKeys(_withModifiers($event => (openLocation(location)), ["prevent"]), ["space"])
                        ],
                        onClick: $event => (openLocation(location))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TablistGrid, {
                            columns: COLUMNS,
                            class: "items-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(location.name), 1),
                                (location.location)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(location.location), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(location.orders), 1),
                              _createElementVNode("div", {
                                "data-test": "location-cell",
                                class: _normalizeClass(hideNumbers.value && 'blur-sm')
                              }, _toDisplayString(dollars(location.total_cents)), 3),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(location.unpacked), 1),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(location.unpaid_carts), 1),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(dropsLabel(location)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onKeydown", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(EmptyState, {
                key: 1,
                plural: "locations",
                description: "Nothing is happening at any location on this day."
              })),
          (locations.value.length && quietCount.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(quietCount.value) + " " + _toDisplayString(quietCount.value === 1 ? 'location' : 'locations') + " had no activity on this day ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

}